/**
 * Some constants that can be used inside the bekocheck advisor.
 */
export class BekocheckConstants {
  // maximum time in days until a local storage element of the advisor should be valid
  static readonly LOCALSTORAGE_TIIMEOUT_DAYS = 14;

  // form inputs
  static readonly APARTMENT_AREA_MIN = 20;
  static readonly INVOICE_MIN_DAYS = 270;
  static readonly INVOICE_MAX_DAYS = 450;

  // Betriebskostenspiegel Vergleichskosten EUR/m2,a
  static readonly VERGLEICHSKOSTEN = {
    grundsteuer: 2.16,
    kaltwasser_abwasser: 3.48,
    heizung_warmwasser: 15.84,
    aufzug: 2.40,
    strassenreinigung: 0.48,
    muellbeseitigung: 1.92,
    gebaeudereinigung: 2.52,
    gartenpflege: 1.80,
    beleuchtung: 0.72,
    schornsteinreinigung: 0.48,
    versicherungen: 3.72,
    hauswart: 2.52,
    antenne_kabel: 0.84,
    sonstige: 0.84
  };
}
